<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import RayaButton from '../raya-ui/RayaButton.vue';
import { colorStyle } from '@/presentation/utils/ui';
const props = withDefaults(defineProps<{
  label?: string; color?: string; variant?: 'flat' | 'tonal' | 'outlined' | 'text' | 'elevated' | 'plain';
  loading?: boolean; disabled?: boolean; block?: boolean; size?: string | number;
  prependIcon?: string; icon?: string | boolean; type?: 'button' | 'submit' | 'reset'; to?: RouteLocationRaw; href?: string;
}>(), { label: undefined, prependIcon: undefined, icon: undefined, to: undefined, href: undefined, variant: 'flat', size: 'default', type: 'button', color: 'primary' });
const emit = defineEmits<{ click: [event: MouseEvent] }>();
const tone = computed(() => ['primary','success','error','warning','info'].includes(props.color) ? props.color as 'primary' | 'success' | 'error' | 'warning' | 'info' : 'default');
const appearance = computed(() => props.variant === 'elevated' ? 'flat' : props.variant === 'plain' ? 'text' : props.variant);
const scale = computed(() => ['x-small','small','large'].includes(String(props.size)) ? props.size as 'x-small' | 'small' | 'large' : 'default');
</script>
<template>
  <RayaButton
    :color="tone"
    :variant="appearance"
    :size="scale"
    :type="type"
    :to="to"
    :href="href"
    :loading="loading"
    :disabled="disabled"
    :block="block"
    :prepend-icon="prependIcon"
    :icon="icon"
    :class="['ava-button', `ava-button--${variant}`, `ava-button--${size}`, { 'ava-button--block': block, 'ava-button--icon': icon }]"
    :style="colorStyle(color)"
    @click="emit('click', $event)"
  >
    <slot>{{ label }}</slot>
  </RayaButton>
</template>
